// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bec2e115","455":"ed7b70c5","488":"07931a3a","977":"84ec0e49"}[chunkId] + ".chunk.js";
};